export const getDescriptionId = (id: string): string => `${id}-dscr`;
export const getErrorId = (id: string): string => `${id}-err`;
